import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { EventMessage, EventType, AuthenticationResult, AccountInfo } from '@azure/msal-browser';
import { HeaderService } from '../../header/shared/header.service';
import { environment } from '../../../environments/environment';

// Declaração para informar ao TypeScript sobre o widget global do Freshchat
declare const window: any;

@Component({
  selector: 'main-layout',
  templateUrl: 'main-layout.component.html',
  styleUrls: ['main-layout.component.css'],
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  
  isExpanded = false;
  logoSaguiCliente: any = null;
  usuario: AccountInfo | null = null;
  iniciaisUsuario: string = '';

  private readonly _destroying$ = new Subject<void>();

  @ViewChild('sidenavContainer') sidenavContainer!: MatSidenavContainer;

  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private headerService: HeaderService
  ) {}

  get sidenavWidth(): string {
    return this.isExpanded ? '220px' : '80px';
  }

  toggleMenu(): void {
    this.isExpanded = !this.isExpanded;
  }

  ngOnInit() {
    this.checkAndConfigureUserSession();
  }

  checkAndConfigureUserSession() {
    const activeAccount = this.msalService.instance.getActiveAccount();
  

    if ( activeAccount) {
      this.usuario = activeAccount;
      // ADICIONADO: Chamada para o método que calcula as iniciais
      this.iniciaisUsuario = this.getIniciais(this.usuario.name); 
      
      this.fetchLogo();
      this.configureChatWidget(this.usuario);
    } else {
      this.usuario = null;
      this.logoSaguiCliente = null;
      // ADICIONADO: Limpa as iniciais ao fazer logout
      this.iniciaisUsuario = ''; 
    }
  }

  // ADICIONADO: O método completo para extrair as iniciais do nome do usuário.
  /**
   * Pega o nome do usuário e retorna as iniciais.
   * Ex: "Pedro Teixeira" -> "PT"
   * @param nomeCompleto O nome do usuário.
   */
  private getIniciais(nomeCompleto: string | undefined): string {
    if (!nomeCompleto) {
      return '';
    }
    // Divide o nome em palavras e remove itens vazios (caso de múltiplos espaços)
    const nomes = nomeCompleto.split(' ').filter(n => n);
    if (nomes.length === 0) {
      return '';
    }
    
    const primeiraInicial = nomes[0][0];
    // Pega a inicial do último nome, mas só se houver mais de um nome
    const ultimaInicial = nomes.length > 1 ? nomes[nomes.length - 1][0] : '';
    
    return (primeiraInicial + ultimaInicial).toUpperCase();
  }

  private fetchLogo() {
    this.headerService.getLogo().subscribe(data => {
      this.logoSaguiCliente = data.body;
    });
  }

  private configureChatWidget(account: AccountInfo) {
    if (window.fcWidget) {
      const user = {
        name: account.name,
        id: account.homeAccountId,
        email: account.username,
        createdAt: new Date().getTime()
      };

      window.fcWidget.setExternalId(user.id);
      window.fcWidget.user.setFirstName(user.name);
      window.fcWidget.user.setEmail(user.email);
      window.fcWidget.user.setProperties({
        cf_plan: "Pro",
        cf_status: "Active"
      });
    } else {
      console.warn('Freshchat widget (fcWidget) não encontrado no objeto window.');
    }
  }

  LogOut() {
    this.msalService.logoutRedirect({
      // Opcional: defina para onde o usuário vai após o logout no servidor da Microsoft
      postLogoutRedirectUri: window.location.origin 
    });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}